import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id ED8AF9CE-E555-49C9-8E7E-F9B85CD94CDF
 * name launch
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/launch.svg
 * tags
 */
export const LaunchIcon = createSvgIcon(<><path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" /></>, 'LaunchIcon');
export default LaunchIcon